export type Change = { kind: 'none' } | { kind: 'up' | 'down' | 'flat'; ratio: number };

/**
 * Change of a figure against the previous period. A zero previous value has no meaningful
 * percentage, so it reads as "no previous data" rather than +∞%.
 */
export function computeChange(current: number, previous: number): Change {
  if (previous === 0) return { kind: 'none' };
  const ratio = (current - previous) / Math.abs(previous);
  if (ratio > 0) return { kind: 'up', ratio };
  if (ratio < 0) return { kind: 'down', ratio: Math.abs(ratio) };
  return { kind: 'flat', ratio: 0 };
}
